const touchpoints = require('od-modules/xsell/config/touchpoints_names');
const appContext = require('od-modules/xsell/config/app_context');


const DESKTOP_WAPB3 = {
    2: {
        [touchpoints.confirmation_hotels_emerginglayer]: 's.layer_emlold',
        [touchpoints.confirmation_hotels_iframe]: 's.cp_emlold',
    },
    3: {
        [touchpoints.mytripsdetails_hotels_emerginglayer]: 's.layer_emlnew',
        [touchpoints.mytripsdetails_hotels_iframe]: 's.mb_emlnew',
    },
};

const MOBILE_WAPB3 = {
    2: {
        [touchpoints.confirmation_hotels_emerginglayer]: 's.layer_old',
        [touchpoints.confirmation_hotels_banner]: 's.banner_old',
    },
    3: {
        [touchpoints.mytripsdetails_hotels_emerginglayer]: 's.layer_new',
        [touchpoints.mytripsdetails_hotels_banner]: 's.banner_new',
    },
};


function getWapb3ForPartition(partition, touchpoint) {
    const wapb3ForPlatform = appContext.isDesktopFlow() ? DESKTOP_WAPB3 : MOBILE_WAPB3;

    return Odigeo._.get(wapb3ForPlatform, `${partition}.${touchpoint}`, '');
}

module.exports = getWapb3ForPartition;
